import Swiper, {Autoplay} from 'swiper';

export default class TestimonialSlider {
  constructor(sliderSelector = '.js-testimonial-slider') {
    this.sliderSelector = sliderSelector;
  }

  init = () => {
    const swiper = new Swiper(this.sliderSelector, {
      modules: [Autoplay],
      speed: 1500,
      autoplay: true,
      loop: true,
      spaceBetween: 40,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        bulletClass: 'testimonials__bullet',
        bulletActiveClass: 'testimonials__bullet--active',
        clickable: true
      },
      breakpoints: {
        900: {
          slidesPerView: 2,
          spaceBetween: 40
        }
      }
    });
  };
}
